import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 30000
  // withCredentials: true // send cookies when cross-domain requests
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add Authorization header to every request
    if (UserModule.token) {
      config.headers['Authorization'] = `Bearer ${UserModule.token}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // WeWalk backend uses ApiResponse<ApiStatus, Data> format
    // success = status.code === 0 or "success"
    // error = status.code !== 0 or "error"
    const res = response.data

    // If response has status.code, check it
    if (res.status && res.status.code !== undefined) {
      // Support both numeric (0, 1, 2, 3) and string codes ("success", "error", "unauthorized", "tokenexpired")
      const code = res.status.code
      const isSuccess = code === 0 || code === 'success'
      const isUnauthorized = code === 2 || code === 'unauthorized'
      const isTokenExpired = code === 3 || code === 'tokenexpired'

      if (!isSuccess) {
        // Token expired or unauthorized
        if (isUnauthorized || isTokenExpired) {
          MessageBox.confirm(
            'Your session has expired. Please login again.',
            'Session Expired',
            {
              confirmButtonText: 'Login',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }
          ).then(() => {
            UserModule.ResetToken()
            location.reload()
          })
          return Promise.reject(new Error(res.status.message || 'Session expired'))
        }

        // Other errors
        Message({
          message: res.status.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error(res.status.message || 'Error'))
      }
    }

    // Return full response for successful requests
    return response
  },
  (error) => {
    Message({
      message: error.message || 'Network error',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
